<script>
import PhotoUploader from '@components/uploaders/photo-uploader.vue';
import {
  adminPanelMethods,
  adminPanelComputed,
  clientComputed,
  mediaComputed,
  authComputed,
  clientMethods,
  mediaMethods,
  programComputed,
  programMethods,
  clientProgramMethods,
  modalMethods,
  organizationComputed,
} from '@state/helpers';
import { clientModelMixin } from '@mixins/models/client-model-mixin';
import { mask } from 'vue-the-mask';
import cloneDeep from 'lodash/cloneDeep';
import has from 'lodash/has';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import EditableText from '@components/editables/editable-text.vue';
import { required, email, decimal } from 'vuelidate/lib/validators';
const touchMap = new WeakMap();

export default {
  mixins: [clientModelMixin],
  components: {
    PhotoUploader,
    EditableText,
  },
  directives: { mask },
  props: {
    client: {
      type: Object,
      required: false,
      default: null,
    },
    content: {
      type: Object,
      required: false,
      default: null,
    },
  },
  validations: {
    clientObj: {
      profile: {
        firstName: {
          required,
          isPlaceholder(value) {
            if (value === 'First Name') {
              return false;
            } else return true;
          },
        },
        lastName: {
          required,
          isPlaceholder(value) {
            if (value === 'Last Name') {
              return false;
            } else return true;
          },
        },
        phone: {
          isPhone(value) {
            if (value) {
              return /^\+(?:[0-9]●?){6,14}[0-9]$/.test(value);
            } else return true;
          },
        },
        dob: {
          isDateInFuture(value) {
            const dateISO = moment(value).toISOString();
            const is18ISO = moment().toISOString();

            const date = moment(dateISO);
            const is18 = moment(is18ISO).subtract(18, 'years');

            if (
              value === null ||
              value === '' ||
              (date && value && date.isBefore(is18))
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
      },
      progress: {
        goals: {
          weight: {
            value: {
              decimal,
            },
          },
          waist: {
            value: {
              isNumber(value) {
                if (value) {
                  return typeof value === 'number';
                } else return true;
              },
            },
          },
          bmi: {
            value: {
              decimal,
            },
          },
        },
      },
      email: {
        required,
        email,
      },
    },
  },
  data() {
    return {
      photoPreview: null,
      genderOptions: ['Male', 'Female', 'Not specified'],
      injury: null,
      initInjury: null,
      healthCondition: null,
      initHealthCondition: null,
      subscriptionLevel: null,
      calculatedHeight: null,
      initCalculatedHeight: null,
      calculatedWeight: null,
      initCalculatedWeight: null,
      listenToError: false,
      formErr: null,
      hasChanges: false,
      clientObj: {},
      isPaid: false,
      imgPlaceHolder: require('@assets/images/placeholder-photo-upload.svg'),
      isSubmitting: false,
      componentKey: 0,
    };
  },
  beforeMount() {
    this.clientObj = this.client
      ? cloneDeep({ ...this.getClientModel(), ...this.selectedClient })
      : cloneDeep({
          ...this.getClientModel(),
          ...this.addNewClientPlaceHolder(),
        });

    this.initialClientObj = this.client
      ? cloneDeep({ ...this.getClientModel(), ...this.selectedClient })
      : cloneDeep({
          ...this.getClientModel(),
          ...this.addNewClientPlaceHolder(),
        });

    this.injury =
      this.clientObj.profile.injuries &&
      this.clientObj.profile.injuries.length > 0
        ? this.clientObj.profile.injuries.join(', ')
        : null;
    this.initInjury =
      this.clientObj.profile.injuries &&
      this.clientObj.profile.injuries.length > 0
        ? this.clientObj.profile.injuries.join(', ')
        : null;

    this.healthCondition =
      this.clientObj.profile.healthConditions &&
      this.clientObj.profile.healthConditions.length > 0
        ? this.clientObj.profile.healthConditions.join(', ')
        : null;
    this.initHealthCondition =
      this.clientObj.profile.healthConditions &&
      this.clientObj.profile.healthConditions.length > 0
        ? this.clientObj.profile.healthConditions.join(', ')
        : null;
    this.initSubscriptionLevel = '';
    this.subscriptionLevel = '';
  },
  mounted() {
    this.isPaid = !this.isCurrentlyFree;
    if (this.$refs && this.$refs.inputToggleInput) {
      this.$refs.inputToggleInput.checked = this.isPaid;
    }
    this.calculatedWeight = {
      weightInKilograms: this.weightInKilograms,
      weightInPounds: this.weightInPounds,
      hasChanges: false,
    };
    this.initCalculatedWeight = cloneDeep(this.calculatedWeight);

    this.calculatedHeight = {
      feet: this.feet,
      inches: this.inches,
      centimeters: this.centimeters,
      hasChanges: false,
    };
    this.initCalculatedHeight = cloneDeep(this.calculatedHeight);

    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      if (modalId === 'notify-modal') {
        // This is clearing the form on error. Not sure what the purpose was?
        // this.clearFormOnCreate();
      }
    });
  },
  computed: {
    ...clientComputed,
    ...mediaComputed,
    ...authComputed,
    ...adminPanelComputed,
    ...programComputed,
    ...organizationComputed,
    isCurrentlyFree() {
      let isFree = false;
      if (!this.client) {
        isFree = true;
      }
      if (this.client) {
        if (
          // Expired Plan but free
          this.clientObj &&
          this.clientObj.profile &&
          has(this.clientObj.profile, 'subscribed') &&
          has(this.clientObj.profile, 'end_date') &&
          moment(this.clientObj.profile.end_date).isBefore() &&
          this.clientObj.profile.subscribed
        ) {
          isFree = true;
        }
        if (
          // No plan but free
          this.clientObj &&
          this.clientObj.profile &&
          !has(this.clientObj.profile, 'subscribed_plan') &&
          !has(this.clientObj.profile, 'end_date') &&
          has(this.clientObj.profile, 'subscribed') &&
          this.clientObj.profile.subscribed
        ) {
          isFree = true;
        }

        if (
          // No plan but free
          this.clientObj &&
          this.clientObj.profile &&
          has(this.clientObj.profile, 'subscribed_plan') &&
          !this.clientObj.profile.subscribed_plan &&
          has(this.clientObj.profile, 'end_date') &&
          !this.clientObj.profile.end_date &&
          has(this.clientObj.profile, 'subscribed') &&
          this.clientObj.profile.subscribed
        ) {
          isFree = true;
        }
        if (
          // No plan but free
          this.clientObj &&
          this.clientObj.profile &&
          has(this.clientObj.profile, 'subscribed_plan') &&
          !this.clientObj.profile.subscribed_plan &&
          has(this.clientObj.profile, 'end_date') &&
          !this.clientObj.profile.end_date &&
          has(this.clientObj.profile, 'subscribed') &&
          !this.clientObj.profile.subscribed
        ) {
          isFree = false;
        }
      }
      return isFree;
    },
    subscriptionName() {
      let plan = '';
      let planId = '';
      if (this.clientObj) {
        if (
          this.clientObj &&
          this.clientObj.profile &&
          has(this.clientObj.profile, 'subscribed_plan') &&
          this.clientObj.profile.subscribed_plan
        ) {
          planId = this.clientObj.profile.subscribed_plan;
        } else if (
          this.clientObj &&
          this.clientObj.invitation &&
          has(this.clientObj.invitation, 'price_plan') &&
          this.clientObj.invitation.price_plan
        ) {
          planId = this.clientObj.invitation.price_plan;
        }
      }

      if (
        this.currentUser.roles.isTrainer &&
        this.currentUser.trainer.myProducts &&
        this.currentUser.trainer.myProducts.length > 0 &&
        this.currentUser.trainer.myProducts[0].plans &&
        this.currentUser.trainer.myProducts[0].plans.length > 0
      ) {
        plan = this.currentUser.trainer.myProducts[0].plans.find(
          (plan) => plan.id === planId
        );
      }
      if (plan) {
        return {
          label: plan.nickname + ' - $' + plan.unit_amount / 100,
          ...plan,
        };
      }
      return plan;
    },
    trainerProductPricing() {
      if (this.currentUser.trainer.myProducts.length > 0) {
        return this.currentUser.trainer.myProducts[0].plans.map((plan) => {
          return {
            label: plan.nickname + ' - $' + plan.unit_amount / 100,
            ...plan,
          };
        });
      } else {
        return [];
      }
    },
    clientImg() {
      // Get client image dynamically
      return this.tempPhotoPreview
        ? this.tempPhotoPreview
        : this.clientObj.profile.mediaAssets.avatarImage.url
        ? this.clientObj.profile.mediaAssets.avatarImage.url
        : this.imgPlaceHolder;
    },
    injuryHasChanges() {
      // Listen to injury changes
      return this.injury !== this.initInjury;
    },
    healthConditionHasChanges() {
      return this.healthCondition !== this.initHealthCondition;
    },
    subscriptionLevelHasChanges() {
      // Listen to subscription changes
      return !isEqual(
        this.subscriptionLevel === null ? '' : this.subscriptionLevel,
        this.initSubscriptionLevel
      );
    },
    weightInPounds() {
      // Calculate lb dynamically
      return this.clientObj.progress &&
        this.clientObj.progress.initial.weight.value &&
        this.clientObj.progress.initial.weight.isImperial
        ? this.clientObj.progress.initial.weight.value
        : null;
    },
    weightInKilograms() {
      // Calculate kg dynamically
      return this.clientObj.progress &&
        this.clientObj.progress.initial.weight.value &&
        !this.clientObj.progress.initial.weight.isImperial
        ? this.clientObj.progress.initial.weight.value
        : null;
    },
    calculatedWeightHasChanges() {
      // Listen to weight changes
      return !isEqual(this.initCalculatedWeight, this.calculatedWeight);
    },
    feet() {
      // Calculate feet dynamically
      return this.clientObj.progress.initial.height.value &&
        this.clientObj.progress.initial.height.isImperial
        ? this.clientObj.progress.initial.height.value >= 12
          ? Math.floor(this.clientObj.progress.initial.height.value / 12)
          : 0
        : null;
    },
    inches() {
      // Calculate inches dynamically
      return this.clientObj.progress.initial.height.value &&
        this.clientObj.progress.initial.height.isImperial
        ? this.clientObj.progress.initial.height.value >= 12
          ? this.clientObj.progress.initial.height.value - this.feet * 12
          : this.clientObj.progress.initial.height.value
        : null;
    },
    centimeters() {
      // Calculate cm dynamically
      return this.clientObj.progress.initial.height.value &&
        !this.clientObj.progress.initial.height.isImperial
        ? this.clientObj.progress.initial.height.value
        : null;
    },
    calculatedHeightHasChanges() {
      // Listen to height changes
      return !isEqual(this.initCalculatedHeight, this.calculatedHeight);
    },
    dob() {
      if (this.clientObj && this.clientObj.profile) {
        if (this.clientObj.profile.dob) {
          return moment.utc(this.clientObj.profile.dob).format('MM/DD/YYYY');
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    isImperial() {
      // Dynamically check trainer's preferred unit
      // Here not every trainer have the 'preferredUnit' flag so the default in imperial unless set metric
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isTrainer &&
        this.currentUser.trainer &&
        this.currentUser.trainer.preferredUnit &&
        this.currentUser.trainer.preferredUnit !== 'metric'
      );
    },
    isPhotoUploaded() {
      return this.hasNewMedia('cover', 'clients');
    },
  },
  methods: {
    ...adminPanelMethods,
    ...clientMethods,
    ...mediaMethods,
    ...programMethods,
    ...clientProgramMethods,
    ...modalMethods,
    calculateBmi(weight, height) {
      if (weight && height) {
        const value = (weight / height / height) * 703;
        return isNaN(value) ? 0 : value.toFixed(2);
      } else {
        return 0;
      }
    },
    delayTouch($v) {
      $v.$reset();
      if (touchMap.has($v)) {
        clearTimeout(touchMap.get($v));
      }
      touchMap.set($v, setTimeout($v.$touch, 1000));
    },
    addNewClientPlaceHolder() {
      // If new client add name placeholders
      return {
        profile: {
          ...this.getClientModel().profile,
          firstName: '',
          lastName: '',
        },
      };
    },
    clearFormOnCreate() {
      this.clientObj = this.client
        ? cloneDeep({ ...this.getClientModel(), ...this.selectedClient })
        : cloneDeep({
            ...this.getClientModel(),
            ...this.addNewClientPlaceHolder(),
          });
      this.setTempPhotoPreview(null);
      this.setClearUploadedMediaStates();
      this.setSignedPostData();
      this.setIsNewMediaAsset(false);
      this.injury = this.initInjury;
      this.healthCondition = this.initHealthCondition;
      this.formErr = null;
      this.calculatedHeight = cloneDeep(this.initCalculatedHeight);
      this.calculatedWeight = cloneDeep(this.initCalculatedWeight);
      this.subscriptionLevel = this.initSubscriptionLevel;
      this.componentKey++;
      this.listenToError = false;
      this.isSubmitting = false;
      this.isPaid = false;
      this.$v.$reset();
    },
    clearFormOnUpdate() {
      this.clientObj = this.client
        ? cloneDeep({ ...this.getClientModel(), ...this.selectedClient })
        : cloneDeep({
            ...this.getClientModel(),
            ...this.addNewClientPlaceHolder(),
          });
      this.initialClientObj = this.client
        ? cloneDeep({ ...this.getClientModel(), ...this.selectedClient })
        : cloneDeep({
            ...this.getClientModel(),
            ...this.addNewClientPlaceHolder(),
          });
      this.setTempPhotoPreview(null);
      this.setIsNewMediaAsset(false);
      this.initInjury = cloneDeep(this.injury);
      this.initHealthCondition = cloneDeep(this.healthCondition);
      this.formErr = null;
      this.listenToError = false;
      this.$v.$reset();
      this.initCalculatedWeight = cloneDeep(this.calculatedWeight);
      this.initCalculatedHeight = cloneDeep(this.calculatedHeight);
    },
    async create() {
      // Create client
      this.isSubmitting = true;
      await this.handleSubmission();
      this.listenToError = true;
      this.$v.$touch();
      if (
        !this.$v.$invalid &&
        (!this.isPaid || (this.isPaid && this.subscriptionName))
      ) {
        const payload = this.clientObj;
        // TODO: We'll want some kind of loading indicator/check
        // for media upload success prior to create

        delete payload.hasUnreadMessages;
        this.createClient({ clientObj: payload })
          .then(async (res) => {
            if (res && res.client) {
              this.setUpdateClientItem(res.client);
              this.setHideAdminPanel();
              this.clearFormOnCreate();
              this.clearMedia();

              this.isSubmitting = false;

              if (window.clevertap) {
                const clientEmail = payload.email;
                const trainerEmail = this.trainerEmail;
                window.clevertap.event.push('Create Client', {
                  client: clientEmail,
                  trainer: trainerEmail,
                  app: 'Tandem',
                });
              }

              if (this.$route.name === 'clients') {
                this.fetchAllClientProgram(res.client).catch((e) =>
                  console.log(e)
                );
              }
            } else {
              this.setNotifyModalContext({
                textMain: 'Something went wrong! Please try again.',
              });
              this.$bvModal.show('notify-modal');
            }
          })
          .catch((e) => console.log(e));
      }
    },

    handleUpdate(payload) {
      delete payload.hasUnreadMessages;
      this.updateClient({ clientObj: payload })
        .then(async (res) => {
          if (res.client) {
            await this.setSelectedClient(payload);
            await this.setHideAdminPanel();
            await this.clearFormOnUpdate();
            this.clearMedia();
            this.isSubmitting = false;

            if (window.clevertap) {
              const clientEmail = payload.email;
              const trainerEmail = this.trainerEmail;
              window.clevertap.event.push('Edit Client', {
                client: clientEmail,
                trainer: trainerEmail,
                app: 'Tandem',
              });
            }
          }
        })
        .catch((e) => console.log(e));
    },
    async update() {
      this.isSubmitting = true;
      this.handleSubmission(); // set all form values to clientObj
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = this.clientObj;
        await this.handleUpdate(payload);
      }
    },
    handleSave() {
      this.client ? this.update() : this.create();
    },
    handleSubmission() {
      // Build clientObj for post request
      // make sure we have proper height in inches if no feet
      const heightInInches =
        this.calculatedHeight.inches && this.calculatedHeight.feet
          ? parseInt(this.calculatedHeight.inches) +
            parseInt(this.calculatedHeight.feet) * 12
          : this.calculatedHeight.feet
          ? parseInt(this.calculatedHeight.feet) * 12
          : this.calculatedHeight.inches
          ? this.calculatedHeight.inches
          : null;

      this.clientObj.progress.initial.height.value = heightInInches;
      this.clientObj.progress.initial.height.isImperial = true;
      this.clientObj.progress.initial.weight.value = this.calculatedWeight
        .weightInPounds
        ? parseInt(this.calculatedWeight.weightInPounds)
        : null;
      this.clientObj.progress.initial.weight.isImperial = true;

      this.clientObj.progress.goals.bmi.isImperial = true;
      this.clientObj.progress.goals.waist.isImperial = true;
      this.clientObj.progress.goals.weight.isImperial = true;
      this.clientObj.profile.injuries = this.injury
        ? this.injury.split(', ', -1)
        : []; // add to injuries array
      this.clientObj.profile.healthConditions = this.healthCondition
        ? this.healthCondition.split(', ', -1)
        : []; // add to healthConditions array
      this.clientObj.trainer_id = this.trainerId || '0';
      this.clientObj.org_id = this.userOrgId || '0';
      if (!this.client) {
        this.clientObj.password = '';
      }

      if (this.clientObj && this.clientObj.profile) {
        this.clientObj = {
          ...this.clientObj,
          profile: { ...this.clientObj.profile, subscribed: !this.isPaid },
        };
      }

      if (
        this.clientObj &&
        this.clientObj.profile &&
        this.clientObj.profile.dob
      ) {
        this.clientObj.profile.dob = moment(
          this.clientObj.profile.dob
        ).toISOString();
      }
    },
    setGender(val) {
      this.selectedClient.profile.gender = val;
    },
    toggled(e) {
      this.isPaid = e.target.checked;
      if (
        this.clientObj &&
        this.clientObj.profile &&
        has(this.clientObj.profile, 'subscribed') &&
        has(this.clientObj.profile, 'end_date') &&
        !this.clientObj.profile.subscribed &&
        moment(this.clientObj.profile.end_date).isBefore()
      ) {
        this.clientObj = {
          ...this.clientObj,
          profile: { ...this.clientObj.profile, subscribed: !e.target.checked },
        };
      }

      if (
        this.clientObj &&
        this.clientObj.profile &&
        !has(this.clientObj.profile, 'subscribed')
      ) {
        this.clientObj = {
          ...this.clientObj,
          profile: { ...this.clientObj.profile, subscribed: !e.target.checked },
        };
      }

      if (
        this.clientObj &&
        this.clientObj.profile &&
        has(this.clientObj.profile, 'subscribed') &&
        has(this.clientObj.profile, 'end_date') &&
        !this.clientObj.profile.end_date
      ) {
        this.clientObj = {
          ...this.clientObj,
          profile: { ...this.clientObj.profile, subscribed: !e.target.checked },
        };
      }
    },
    setPricePlan(val) {
      if (val && val.id) {
        if (
          (this.clientObj &&
            this.clientObj.invitation &&
            has(this.clientObj.invitation, 'price_plan') &&
            !this.clientObj.invitation.price_plan) ||
          !has(this.clientObj.invitation, 'price_plan')
        ) {
          this.clientObj = {
            ...this.clientObj,
            invitation: { ...this.clientObj.invitation, price_plan: val.id },
          };
        } else {
          this.clientObj = {
            ...this.clientObj,
            profile: { ...this.clientObj.profile, subscribed_plan: val.id },
          };
        }
      }
    },
    setFirstName(value) {
      this.clientObj.profile.firstName = value;
    },
    setLastName(value) {
      this.clientObj.profile.lastName = value;
    },
    setDob(event) {
      this.$v.$touch();
      if (event && event.target && event.target.value) {
        this.clientObj.profile.dob = moment(event.target.value).toISOString();
      }
    },
    async fetchAllClientProgram(client) {
      const programPayload = {
        userId: client._id,
        programId: client.program.program_id,
        orgId: client.org_id,
        trainerId: client.trainer_id,
      };
      await this.getProgram(programPayload);
      const todaysDate = moment().format('YYYY-MM-DD');
      const programId = client.program.program_id;
      const clientProgramPayload = {
        id: programId,
        from: 1,
        to: this.selectedProgram.programWeeksNumber
          ? this.selectedProgram.programWeeksNumber
          : 4,
        today: todaysDate,
      };
      if (
        clientProgramPayload.id &&
        clientProgramPayload.from &&
        clientProgramPayload.to &&
        clientProgramPayload.today
      ) {
        await this.getAllClientProgram(clientProgramPayload);
      }
    },
    getHeightInCentimeters(val) {
      if (val) {
        if (val.feet && val.inches) {
          return Math.round((val.feet * 12 + val.inches) * 2.54); // If feet and inches
        } else if (val.feet && !val.inches) {
          // If user didn't add inches
          return Math.round(val.feet * 12 * 2.54);
        } else {
          return Math.round(val.inches * 2.54); // Otherwise it's only inches
        }
      }
    },
    setHeightInCentimeters(val) {
      if (val !== '' && parseInt(val) > 0) {
        // Empty inputs return strings for some reason
        const init = parseInt(val) > 0 ? parseInt(val) / 2.54 : 0; // To init just in case
        if (init >= 12) {
          // Check if height to inches is more that 12 (foot)
          const feet = Math.floor(init / 12); // Convert and get no decimal
          const inches = init - feet * 12; // Convert
          this.calculatedHeight.feet = feet;
          this.calculatedHeight.inches = inches;
        } else {
          // If less that 12 then only inches
          this.calculatedHeight.feet = 0;
          this.calculatedHeight.inches = init;
        }
      } else {
        this.calculatedHeight.feet = 0;
        this.calculatedHeight.inches = 0;
      }
    },
    getWeightInKilograms(val) {
      if (val) {
        return Math.floor(val / 2.20462); // Weight in kg and no decimal places
      }
    },
    setWeightInKilograms(val) {
      if (val !== '' && parseInt(val) > 0) {
        // Data available
        const init = parseInt(val); // Make sure it's a number
        this.calculatedWeight.weightInPounds = init * 2.20462; // convert to pounds
      } else {
        // Otherwise just set to 0
        this.calculatedWeight.weightInPounds = 0;
      }
    },
    getCurrentWaist(val) {
      if (val) {
        // If there is value
        if (this.isImperial) {
          return Math.round(val); // Round and get no decimal
        } else {
          return Math.round(val * 2.54); // Round and get no decimal
        }
      }
    },
    setCurrentWaist(val) {
      if (val !== '' && parseInt(val) > 0) {
        // If there is value
        const init = parseInt(val); // Make sure it's a number
        if (this.isImperial) {
          this.clientObj.progress.initial.waist.value = init; // Everuything in DB is imperial
        } else {
          this.clientObj.progress.initial.waist.value = // If entered value inches then convert
            init > 2.54 ? init / 2.54 : init;
        }
      } else {
        this.clientObj.progress.initial.waist.value = 0; // Make sure we set to zero if input is empty
      }
    },
    getGoalWeight(val) {
      if (val) {
        if (this.isImperial) {
          return Math.round(val); // Round and get no decimal
        } else {
          return Math.round(val / 2.20462); // Round and get no decimal
        }
      }
    },
    setGoalWeight(val) {
      if (val !== '' && parseInt(val) > 0) {
        // If there is value
        const init = parseInt(val); // Make sure it's a number
        if (this.isImperial) {
          this.clientObj.progress.goals.weight.value = init; // Everuything in DB is imperial
        } else {
          this.clientObj.progress.goals.weight.value = init * 2.20462; // If entered value kg then convert
        }
      } else {
        this.clientObj.progress.goals.weight.value = 0;
      }
    },
    getGoalWaist(val) {
      if (val) {
        if (this.isImperial) {
          return Math.round(val); // Round and get no decimal
        } else {
          return Math.round(val * 2.54); // Round and get no decimal
        }
      }
    },
    setGoalWaist(val) {
      if (val !== '' && parseInt(val) > 0) {
        // If there is value
        const init = parseInt(val); // Make sure it's a number
        if (this.isImperial) {
          this.clientObj.progress.goals.waist.value = init; // Everything in DB is imperial
        } else {
          this.clientObj.progress.goals.waist.value =
            init > 2.54 ? init / 2.54 : init; // If entered value cm then convert
        }
      } else {
        this.clientObj.progress.goals.waist.value = 0; // Otherwisw it's zero
      }
    },
  },
  watch: {
    isAdminPanelActive(newVal, oldVal) {
      if (newVal === false) {
        this.clearFormOnCreate();
      }
    },
    uploadedCoverImageUrl(val) {
      if (val) {
        this.clientObj.profile.mediaAssets.avatarImage.url = this.uploadedCoverImageUrl;
      }
    },
    clientObj: {
      handler(newVal, oldVal) {
        if (newVal && oldVal) {
          this.hasChanges = !isEqual(this.initialClientObj, this.clientObj);
          if (!this.hasChanges) {
            this.$v.$reset();
          }
        }
      },
      deep: true,
    },
    isPhotoUploaded() {
      if (typeof this.isPhotoUploaded !== 'undefined') {
        this.clientObj.profile.mediaAssets.avatarImage.url = this.hasNewMedia(
          'cover',
          'clients'
        )
          ? this.hasNewMedia('cover', 'clients').publicUrl
          : this.clientObj.profile.mediaAssets.avatarImage.url;
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="save">
    <div class="row">
      <div
        v-if="!client"
        class="col-2 client-profile-image"
        :style="{ 'background-image': `url(${clientImg})` }"
      />
      <div
        class="col-5 client-name"
        :class="[
          {
            'input-error':
              $v.clientObj.profile.firstName.$error ||
              $v.clientObj.profile.lastName.$error
                ? $v.clientObj.profile.firstName.$error ||
                  $v.clientObj.profile.lastName.$error
                : null,
          },
        ]"
      >
        <label>Name <sup class="required">required</sup></label>
        <div
          class="editable-div"
          :class="[{ 'input-error': $v.clientObj.profile.firstName.$error }]"
        >
          <h1 class="hero-title">
            <EditableText
              v-model.lazy="$v.clientObj.profile.firstName.$model"
              :text="clientObj.profile.firstName"
              placeholderTxt="First Name"
              mode="edit"
              :canEdit="true"
              @update-editable-value="setFirstName"
            />
          </h1>
        </div>
        <div
          class="editable-div"
          :class="[{ 'input-error': $v.clientObj.profile.lastName.$error }]"
        >
          <h1 class="hero-title">
            <EditableText
              v-model.lazy="$v.clientObj.profile.lastName.$model"
              :text="clientObj.profile.lastName"
              placeholderTxt="Last Name"
              mode="edit"
              :canEdit="true"
              @update-editable-value="setLastName"
            />
          </h1>
        </div>
        <transition name="fade">
          <span
            v-if="
              $v.clientObj.profile.firstName.$error ||
                $v.clientObj.profile.lastName.$error
            "
            class="input-error-text"
          >
            {{
              $v.clientObj.profile.firstName.$error &&
              $v.clientObj.profile.lastName.$error
                ? 'First name and Last name required'
                : $v.clientObj.profile.firstName.$error
                ? 'First name is required'
                : 'Last name is required'
            }}
          </span>
        </transition>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <label>Email <sup class="required">required</sup></label>
        <BaseInputText
          name="email"
          v-model.lazy="$v.clientObj.email.$model"
          :class="[{ 'input-error': $v.clientObj.email.$error }]"
          :value="clientObj.email"
          @input="
            delayTouch($v.clientObj.email);
            clientObj.email =
              $event.target.value === '' ? null : $event.target.value;
          "
          placeholder="Add client email"
          :error="$v.clientObj.email.$error ? 'A valid email required' : null"
        />
      </div>
      <div class="col-3">
        <label>Phone</label>
        <BaseInputText
          name="phone"
          v-model.lazy="$v.clientObj.profile.phone.$model"
          :class="[{ 'input-error': $v.clientObj.profile.phone.$error }]"
          :value="clientObj.profile.phone"
          @input="
            delayTouch($v.clientObj.profile.phone);
            clientObj.profile.phone =
              $event.target.value === '' ? null : $event.target.value;
          "
          placeholder="+1111111111"
          :error="
            $v.clientObj.profile.phone.$error
              ? 'Enter a valid phone number'
              : null
          "
        />
      </div>
    </div>

    <div class="row">
      <div class="col profile-picture">
        <label>Profile Picture</label>
        <PhotoUploader
          requestType="clients"
          :hidePlaceholder="true"
          :hidePhotoPreview="true"
          type="cover"
          helper-text="Photos must be .jpg, .jpeg, .gif, or .webp, no larger than 10MB."
        />
      </div>
    </div>

    <h3 class="section-title">
      Personal Information
    </h3>

    <div class="row">
      <div class="col-3">
        <label>Birthday</label>
        <BaseInputText
          name="dob"
          :value="dob"
          v-mask="'##/##/####'"
          @change="setDob"
          placeholder="mm/dd/yyyy"
        />
      </div>
      <div class="col-5 offset-2">
        <label>Injuries</label>
        <BaseInputText
          name="injuries"
          :value="injury"
          @input="
            injury = $event.target.value === '' ? null : $event.target.value
          "
          placeholder="Add injuries"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-3">
        <label>Gender</label>
        <v-select
          name="gender"
          placeholder="Choose gender"
          :options="genderOptions"
          :searchable="false"
          :clearable="false"
          v-model="clientObj.profile.gender"
          @change="setGender"
        />
      </div>
      <div class="col-5 offset-2">
        <label>Health Conditions</label>
        <BaseInputText
          name="injuries"
          :value="healthCondition"
          @input="
            healthCondition =
              $event.target.value === '' ? null : $event.target.value
          "
          placeholder="Add health conditions"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-3">
        <label>Height</label>
        <div class="row">
          <div v-if="calculatedHeight && isImperial" class="col">
            <BaseInputText
              name="feet"
              :value="calculatedHeight.feet"
              @input="
                calculatedHeight.feet =
                  $event.target.value === ''
                    ? null
                    : parseInt($event.target.value)
              "
              placeholder="feet"
              v-mask="'#'"
              type="text"
              min="0"
            />
          </div>
          <div v-if="calculatedHeight && isImperial" class="col">
            <BaseInputText
              name="inches"
              :value="calculatedHeight.inches"
              @input="
                calculatedHeight.inches =
                  $event.target.value === ''
                    ? null
                    : parseInt($event.target.value)
              "
              placeholder="inches"
              v-mask="'##'"
              type="text"
              min="0"
              max="11"
            />
          </div>
          <div v-if="calculatedHeight && !isImperial" class="col">
            <BaseInputText
              type="tel"
              name="cm"
              v-mask="'###'"
              :value="getHeightInCentimeters(calculatedHeight)"
              @change="setHeightInCentimeters($event.target.value)"
              placeholder="cm"
              min="0"
            />
          </div>
        </div>
      </div>
      <div class="col-2">
        <label>Weight</label>
        <BaseInputText
          v-if="calculatedWeight && isImperial"
          name="weight"
          :value="calculatedWeight.weightInPounds"
          v-mask="'###.##'"
          @input="
            calculatedWeight.weightInPounds =
              $event.target.value === '' ? null : $event.target.value
          "
          placeholder="LBS"
          type="number"
          min="0.0"
        />
        <BaseInputText
          v-if="calculatedWeight && !isImperial"
          name="weight"
          v-mask="'###.##'"
          :value="getWeightInKilograms(calculatedWeight.weightInPounds)"
          @change="setWeightInKilograms($event.target.value)"
          placeholder="kg"
          type="tel"
          min="0.0"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <label>Current Waist Size</label>
        <BaseInputText
          name="current_waist_size"
          :value="getCurrentWaist(clientObj.progress.initial.waist.value)"
          @change="setCurrentWaist($event.target.value)"
          v-mask="'###'"
          :placeholder="isImperial ? 'inches' : 'cm'"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <label>Current BMI</label>
        <p class="goalBmi">{{
          calculatedWeight &&
          calculatedWeight.weightInPounds !== null &&
          calculatedHeight &&
          calculatedHeight.feet !== null &&
          calculatedHeight.inches !== null
            ? calculateBmi(
                calculatedWeight.weightInPounds,
                calculatedHeight.feet * 12 + calculatedHeight.inches
              )
            : 0
        }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <h3 class="section-title">
          Account Details
        </h3>
        <label>{{ organizationTitle }} PAY?</label><br />
        <div class="custom-control custom-switch">
          <input
            :key="componentKey"
            ref="inputToggleInput"
            type="checkbox"
            class="custom-control-input"
            id="customSwitches"
            :value="isPaid"
            :disabled="trainerProductPricing.length === 0"
            @input="toggled"
          /><br />
          <p v-show="trainerProductPricing.length === 0"
            >To enable {{ organizationTitle }} PAY for this client.
            <router-link to="/products">Please add a product</router-link></p
          >
          <label
            ref="inputToggleLabel"
            :class="['custom-control-label', { isSubscription: isPaid }]"
            for="customSwitches"
            >{{ isPaid ? 'Request Payment' : 'Free Access' }}</label
          > </div
        ><br />
        <label v-show="isPaid" class="v-select-label"
          >Subscription <sup class="required">required</sup></label
        >
        <v-select
          :key="componentKey"
          name="subscription"
          placeholder="Choose subscription"
          :options="trainerProductPricing"
          :disabled="trainerProductPricing.length === 0"
          :searchable="false"
          :clearable="false"
          :value="subscriptionName"
          @input="setPricePlan"
          v-show="isPaid"
        />
      </div>
      <div class="col-6">
        <h3 id="goals" class="section-title">
          Goals
        </h3>
        <div class="row align-items-start">
          <div class="col-5">
            <label>Goal Weight</label>
            <BaseInputText
              name="goal_weight"
              :class="[
                {
                  'input-error':
                    $v.clientObj.progress.goals.weight.value.$error,
                },
              ]"
              :value="getGoalWeight(clientObj.progress.goals.weight.value)"
              v-mask="'###.##'"
              @change="setGoalWeight($event.target.value)"
              :placeholder="isImperial ? 'LBS' : 'kg'"
              :error="
                $v.clientObj.progress.goals.weight.value.$error
                  ? 'Must be a number'
                  : null
              "
            />
          </div>
          <div class="col-5">
            <label>Goal Waist Size</label>
            <BaseInputText
              name="goal_waist_size"
              type="tel"
              :class="[
                {
                  'input-error': $v.clientObj.progress.goals.waist.value.$error,
                },
              ]"
              :value="getGoalWaist(clientObj.progress.goals.waist.value)"
              v-mask="'###'"
              @change="setGoalWaist($event.target.value)"
              :placeholder="isImperial ? 'inches' : 'cm'"
              :error="
                $v.clientObj.progress.goals.waist.value.$error
                  ? 'Must be a number'
                  : null
              "
            />
          </div>
        </div>
        <div class="row">
          <div class="col-5">
            <label>Goal BMI</label>
            <p class="goalBmi">{{
              calculatedHeight &&
              calculatedHeight.feet !== null &&
              calculatedHeight.inches !== null
                ? calculateBmi(
                    clientObj.progress.goals.weight.value,
                    calculatedHeight.feet * 12 + calculatedHeight.inches
                  )
                : 0
            }}</p>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div
        v-if="
          healthConditionHasChanges ||
            injuryHasChanges ||
            hasChanges ||
            subscriptionLevelHasChanges ||
            calculatedWeightHasChanges ||
            calculatedHeightHasChanges ||
            isNewMediaAsset
        "
        :class="[
          'panel-footer',
          {
            'input-error': listenToError && $v.$invalid,
            'new-client': !client,
          },
        ]"
        ><span v-if="listenToError && $v.$invalid" class="error-instruction"
          >Fix highlighted errors.</span
        >
        <span v-if="!$v.$invalid || !listenToError" class="not-saved"
          >Not saved</span
        >
        <BaseButton
          type="button"
          class="btn-primary btn-clear"
          @click="clearFormOnCreate"
        >
          <BaseIcon name="times" />
          Cancel Changes
        </BaseButton>
        <span class="divider-vertical">&nbsp;</span>
        <BaseButton
          :class="[
            {
              'input-error': isSubmitting || $v.$invalid,
            },
          ]"
          type="button"
          class="btn-primary btn-clear"
          @click="handleSave"
          :disabled="
            isSubmitting || $v.$invalid || (isPaid && !subscriptionName)
          "
        >
          <BaseIcon v-if="!isSubmitting" name="save" />
          <BaseIcon v-if="isSubmitting" name="sync" spin />
          {{ client ? 'Save Changes' : 'Add New Client' }}
        </BaseButton>
      </div>
    </transition>
  </form>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable no-descending-specificity
.required {
  color: $color-red;
  font-size: 0.8rem;
  font-weight: bold;
  left: 5px;
  top: 1px;
}

// stylelint-disable selector-pseudo-element-no-unknown
::v-deep .hero-title {
  margin-bottom: unset !important;
  .input-inline-edit {
    outline-style: none;

    &::placeholder {
      opacity: 0.5;
    }
  }
}

.client-profile-image {
  align-self: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 10px;
  height: 120px;
  margin-left: 2rem;
  margin-right: 2rem;
  max-width: 12.5rem;
  width: 20px;
}

.slide-fade-enter-active {
  transform: translateY(0%);
  transition: all $duration-animation-base ease;
}
.slide-fade-leave-active {
  transform: translateY(0%);
  transition: all $duration-animation-base ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.section-title {
  margin-top: 4rem;
  width: 100%;
}

.col-4 {
  .section-title {
    margin-right: 13rem;
  }
}
// stylelint-disable selector-max-type
form {
  margin-bottom: 13rem;
  .goalBmi {
    font-size: 25px;
  }
  .custom-control {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: 0 !important;
    -webkit-user-select: none; /* Chrome/Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE10+ */

    /* Rules below not implemented in browsers yet */
    -o-user-select: none;
    user-select: none;
    .v-select-label {
      color: red;
    }
  }
  .custom-control-input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: unset;
    outline: 0 !important;
    width: 6.5rem !important;
  }
  .custom-control-label {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: unset;
    cursor: pointer;
    font-size: 1.5rem;
    outline: 0 !important;
    padding: 1rem 5rem;
    &:focus {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: unset;
      border-color: unset !important;
      outline: 0 !important;
    }
    &::before {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: $color-off-white !important;
      border: unset;
      border-color: unset !important;
      border-radius: 3.5rem;
      box-shadow: inset 0 4px 4px rgba($color-black-wo-rgb, 0.06);
      height: 3.5rem !important;
      outline: 0 !important;
      width: 6.5rem !important;
    }
    &::after {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: $color-action !important;
      border-radius: 3.5rem;
      height: calc(3.5rem - 2px);
      left: calc(-2.25rem + 1px);
      outline: 0 !important;
      top: calc(0.25rem + 1px);
      width: calc(3.5rem - 2px);
    }

    &.isSubscription {
      &::before {
        background: rgba($color-primary-one-wo-rgb, 0.22) !important;
        box-shadow: inset 0 4px 4px rgba($color-black-wo-rgb, 0.06);
      }
      &::after {
        left: calc(-0.25rem + 3px);
      }
    }
  }
}

.profile-picture {
  label {
    margin-bottom: unset;
  }
  ::v-deep .photo-preview {
    margin-bottom: 0.5rem;
  }
  ::v-deep .input-photo {
    width: 18rem;
  }
}

.client-name {
  margin-bottom: 4rem;
  label {
    margin-bottom: -5px;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .input-error-text {
    color: transparent;
    opacity: 0;
    transition: opacity $duration-animation-base ease-in-out;
  }
  &.input-error {
    .input-error-text {
      color: $color-input-error-dark;
      display: block;
      margin-bottom: unset;
      margin-top: 1.2rem;
      opacity: 1;
    }
  }

  .editable-div {
    font-size: 3.8rem;
    font-weight: 900;
    line-height: 53px;
    outline-style: none;
    transition: background-image $duration-animation-base ease-in-out;
    width: 100%;

    &.input-error {
      background-image: -webkit-linear-gradient(
        top,
        transparent,
        transparent 51px,
        rgba($color-red-wo-rgb, 0.945) 10px
      );
    }
  }
}

.panel-footer {
  background-color: black;
  border-radius: $size-input-border-radius;
  bottom: 10rem;
  display: flex;
  justify-content: flex-end;
  left: 2rem;
  margin-left: 19rem;
  padding: 1rem 2rem;
  position: fixed;
  right: 2rem;
  z-index: 9999;

  .error-instruction {
    align-self: center;
    color: $color-white;
    font-family: $base-font-family;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    left: 2.2rem;
    position: absolute;
  }

  .not-saved {
    @extend .error-instruction;

    opacity: 0.5;
  }
  .input-error {
    opacity: 0.6;
  }

  &.new-client {
    background-color: $color-header-bg;
    margin-left: unset;
    &.input-error {
      background-color: $color-error-dark;
    }
  }

  &.input-error {
    background-color: $color-error-dark;
  }

  .divider-vertical {
    border-left: 1px solid white;
    height: 2.5rem;
  }

  .btn-primary {
    &:active {
      background: rgba($color-white-wo-rgb, 0.1);
      color: white;
    }

    &:focus {
      background: transparent;
      color: white;
    }

    &:not(:disabled):not(.disabled) {
      &:active {
        background: rgba($color-white-wo-rgb, 0.1);
        color: white;
      }

      &:focus {
        background: transparent;
        color: white;
      }
    }
    &:disabled {
      opacity: 0.5;
    }
  }

  .btn-clear {
    color: white;
  }
}

@media screen and (max-width: 868px) {
  .col-5 {
    max-width: 50%;
  }
  .col-3 {
    flex: 0 0 40%;
    max-width: 35%;
  }
  .col-6 {
    flex: 0 0 60%;
    margin-left: 4%;
    max-width: 58%;
    .col-5 {
      flex: 0 0 49%;
      max-width: 50%;
    }
  }
  .col-4 {
    flex: 0 0 60.333333%;
    max-width: 38%;
  }
}
</style>
